import { createSelector } from 'reselect'
import { sum, uniqueBy } from 'lib/array/arrayUtils'
import { getCheckoutCruiseOfferView } from 'checkout/selectors/view/cruise'

export const getAvailableCruiseBenefits = createSelector(
  (state: App.State) => getCheckoutCruiseOfferView(state),
  (state: App.State) => state.luxPlus.products.subscription,
  (cruiseOfferView, productSubscription): App.Checkout.LuxPlusCruiseBenefits => {
    const cruiseViews = cruiseOfferView.data.flatMap<App.Checkout.CruiseAccommodationItemView>(view => {
      return view.itemViews.filter(itemView => itemView.kind === 'cruise')
    })

    let totalPrice = 0
    let totalBaseMemberPrice = 0
    let totalMemberPrice = 0
    let totalMemberPriceSavings = 0
    let totalLuxPlusStandardSavings = 0
    if (cruiseViews.length > 0) {
      totalPrice = sum(cruiseViews, view => view.totals.price)
      totalBaseMemberPrice = sum(cruiseViews, view => view.totals.memberPrice)
      totalMemberPrice = sum(
        cruiseViews,
        view => view.totals.memberPrice || view.totals.price,
      )
      totalMemberPriceSavings = sum(
        cruiseViews,
        view => view.totals.memberPrice > 0 ? view.totals.price - view.totals.memberPrice : 0,
      )
      totalLuxPlusStandardSavings = sum(
        cruiseViews,
        view => view.cabinSelection?.pricing.total.luxPlusStandardSaving ?? 0,
      )
    }

    // Checkout upsell is a join offer for non-members — scope to fee-waived offers.
    const offersWithJoinFeeWaived = productSubscription?.offers?.filter(offer => offer.joinFeeWaived)

    let hasLuxPlusInclusions = false
    const subscriptionViews = offersWithJoinFeeWaived?.map<App.Checkout.LuxPlusCheckoutBenefitsSubscriptionViewWithInclusions>(offer => {
      const inclusions = cruiseViews.flatMap(view => {
        const luxPlusInclusions = view.item?.luxPlusInclusionsByTier?.[offer.tier] ?? []
        return luxPlusInclusions
      })

      if (inclusions.length) {
        hasLuxPlusInclusions = true
      }

      return {
        inclusions: uniqueBy(inclusions, incl => incl.description),
        offer,
      }
    }) ?? []

    return {
      inclusions: subscriptionViews.flatMap(view => view.inclusions) ?? [],
      subscriptionViews,
      hasLuxPlusInclusions,
      totalPrice,
      totalMemberPrice,
      totalBaseMemberPrice,
      totalMemberPriceSavings,
      totalLuxPlusStandardSavings,
    }
  })
